module.exports = __webpack_public_path__ + "static/img/英文LOGO.6a1ee1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/英文LOGO.png
// module id = oUAH
// module chunks = 1